import type { ContentObjectList } from 'models';
import { getUserName } from 'models';
import { useState } from 'react';
import { Avatar, Flex, Modal, Paragraph, Text } from 'ui';
import { images } from 'common/utils';
import { ContentObjectRenderer } from '../../content-object-renderer';

type P = {
  item: ContentObjectList;
};

const getTitle = (item: ContentObjectList) => {
  if (item.type === 'poll') {
    return item.poll.questions[0]?.question ?? '';
  }
  if (item.type === 'post') {
    return item.post.textContent ?? '';
  }
  return '';
};

const getCoverName = (item: ContentObjectList) => {
  if (item.contentableType === 'Program') {
    return 'Program';
  }

  return item.contentableType === 'Community' ? item.postInCommunities[0].name : undefined;
};

const getCoverImage = (item: ContentObjectList) => {
  if (item.contentableType === 'Program') {
    return undefined;
  }

  const community = item.contentableType === 'Community' ? item.postInCommunities[0] : undefined;
  const attachment = item.attachments.find((attachment_) => attachment_.contentType.startsWith('image'));

  return attachment?.url ?? community?.coverPhoto.url ?? images.default.communityCoverPhoto;
};

const PinnedContentObjectCard = ({ item }: P) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const coverImage = getCoverImage(item);
  const coverName = getCoverName(item);

  return (
    <>
      <button
        className="pinned-content-object-card"
        onClick={() => {
          setIsModalOpened(true);
        }}
        type="button"
      >
        <div className="pinned-content-object-card__image">
          <img alt="" src={coverImage} />
          <div className="pinned-content-object-card__image__name">
            <Text ellipsis size="small">
              {coverName}
            </Text>
          </div>
        </div>
        <div className="pinned-content-object-card__content">
          <div className="pinned-content-object-card__content__text">
            <Paragraph ellipsis={{ rows: 2 }}>{getTitle(item)}</Paragraph>
          </div>
          <Flex justify="flex-end">
            <Avatar photo={item.author.profilePhoto} size={20} />
          </Flex>
        </div>
      </button>
      <Modal
        isOpened={isModalOpened}
        maskClosable={false}
        onCancel={() => {
          setIsModalOpened(false);
        }}
        title={getUserName(item.author)}
        width="medium"
      >
        <Modal.HugContent>
          <ContentObjectRenderer forceCommentsOpen item={item} view="other" />
        </Modal.HugContent>
      </Modal>
    </>
  );
};

export default PinnedContentObjectCard;
